import { gsap, ScrollTrigger, ScrollToPlugin } from "gsap/all";
import { BREAKPOINTS } from "../styles/variables/breakpoints";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const parallax = (target, number) => {
  if (!target) return;
  const mm = gsap.matchMedia();

  mm.add(`(min-width: ${BREAKPOINTS.sm}px)`, context => {
    gsap.fromTo(
      target,
      { yPercent: -number },
      {
        yPercent: number,
        ease: "none",
        scrollTrigger: {
          trigger: target,
          scrub: 1,
        },
      }
    );
  });
};

const animations = {
  ...gsap,
  ScrollTrigger,
  ScrollToPlugin,
  parallax,
};

export default animations;
